<template>
    <div>
        <h1>Détails d'une passerelle</h1>
        <div class="text-center text-danger my-2" v-if="loading">
            <b-spinner class="align-middle"></b-spinner>
             <strong>Chargement des données…</strong>
        </div>
        <b-alert v-else-if="errors.length" variant="danger" show>
            <p v-for="error in errors" :key="error" class="mb-0">{{error}}</p>
        </b-alert>
        <ul v-else>
            <li>Numéro de série : {{ serial }}</li>
            <li>Intitulé : {{ label }}</li>
            <li>Dernier contact : {{ lastSeen || 'Inconnu' }}</li>
            <li>Statut :
                <status-summary :showText="true" :statuses="summary"></status-summary>
            </li>
            <li>Événements en cours :
                <span v-if="events.length=== 0" class="text-info">Aucun</span>
                <ul v-else>
                    <li v-for="event in events" v-bind:key="event.key">{{ event.event }} {{event.startTime }} – {{ event.lastSeen }}</li>
                </ul>
            </li>
            <li v-if="values.length">Dernières valeurs remontées :
                <ul>
                    <li v-for="value in values" v-bind:key="value.key">{{ value.key }} : {{ value.value }} {{ value.time}}</li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script>
    import axios from "axios";
    import {API_URL, REFRESH_FREQUENCY} from "../../variables";
    import StatusSummary from "../StatusSummary";

    function updateData() {
        axios
            .get(API_URL + "/user/gateway/details", {params: {id: this.id}})
            .then(response => {
                for (let p in response.data) {
                    this[p] = response.data[p];
                }
            })
            .catch(() => this.errors.push("Une erreur est survenue lors du traitement de la requête"))
            .finally(() => {
                this.loading = false
                this.timeout = window.setTimeout(() => updateData.call(this), REFRESH_FREQUENCY * 1000);
            });
    }

    export default {
        name: "GatewayDetails",
        props: ["id"],
        components: {StatusSummary},
        data() {
            return {
                serial: null,
                label: null,
                summary: [],
                events: [],
                values: [],
                errors: [],
                loading: true,
                timeout: null
            };
        },
        mounted() {
            updateData.call(this);
        },
        beforeDestroy() {
            window.clearTimeout(this.timeout);
        }
    }
</script>

<style scoped>

</style>